module.exports = __webpack_public_path__ + "b3485a3acc8785ab92427a73288be88f.svg";